import axios from "axios";
import { baseURL } from "../../../base-url.js";

export default {
  async generateSalonsOverview({ commit }) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(baseURL + "/report/generateGeneralSalonsReport", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      commit("setSalonsOverview", response.data);
    } catch (error) {
      return error.response;
    }
  },

  async generateSalonDetailedReport({ commit }, params) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.get(`${baseURL}/report/generateDetailedSalonReport`, {
        params: {
          salonId: params.salonId,
          startDate: params.startDate,
          endDate: params.endDate
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      commit("setSalonDetailedReport", response.data);
    } catch (error) {
      console.error("Błąd generowania salonDetailedReport:");
    }
  },

  async generateSalariesReport({ commit }, params) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.get(`${baseURL}/report/generateSalariesReport`, {
        params: {
          startDate: params.startDate,
          endDate: params.endDate
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      commit("setSalariesReport", response.data);
    } catch (error) {
      console.error("Błąd generowania salariesReport:");
    }
  },

  async generateDiscountSummary({ commit }, params) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.get(`${baseURL}/report/generateDiscountSummary`, {
        params: {
          salonId: params.salonId,
          startDate: params.startDate,
          endDate: params.endDate
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      commit("setDiscountSummary", response.data);
    } catch (error) {
      commit("setDiscountSummary", {
        discountCount: 0,
        totalDiscountAmount: 0
      });
      return error.response;
    }
  },

  async createDailyReport(_, dailyReport) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.post(baseURL + "/report/createDailyReport", dailyReport, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  async getSalonDailyReports({ commit }, params) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.get(`${baseURL}/report/getSalonDailyReports`, {
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          salonId: params.salonId
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      commit("setSalonDailyReports", response.data);
    } catch (error) {
      console.error("Błąd generowania salariesReport:");
    }
  },

  async fetchTodayPaymentsReport({ commit }, salonId) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.get(`${baseURL}/report/getTodayPaymentsReport`, {
        params: { salonId },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      commit("setTodayPaymentsReport", response.data);
    } catch (error) {
      console.error("Błąd generowania todayPaymentsReport:");
    }
  }

}
